import React, {
  FC,
  ReactNode,
  useCallback,
  useEffect,
  useRef,
  useState,
} from 'react'
import useEmblaCarousel from 'embla-carousel-react'
import BidCarouselPrev from '@components/BidAuctionCarousel/BidCarouselPrev'
import BidCarouselNext from '@components/BidAuctionCarousel/BidCarouselNext'

const CardSlider: FC<{
  children: ReactNode | ((props: { trackHeight: number }) => ReactNode)
}> = ({ children }) => {
  const [viewportRef, embla] = useEmblaCarousel({
    slidesToScroll: 1,
    skipSnaps: false,
    align: 'start',
    containScroll: 'trimSnaps',
  })
  const [prevBtnEnabled, setPrevBtnEnabled] = useState<any>(false)
  const [nextBtnEnabled, setNextBtnEnabled] = useState<any>(false)
  const [trackHeight, setTrackHeight] = useState<any>(false)
  const trackRef = useRef<any>(null)
  const emblaRef = useRef<any>(null)

  const scrollPrev = useCallback(() => embla && embla.scrollPrev(), [embla])
  const scrollNext = useCallback(() => embla && embla.scrollNext(), [embla])
  const onSelect = useCallback(() => {
    if (!embla) return
    setPrevBtnEnabled(embla.canScrollPrev())
    setNextBtnEnabled(embla.canScrollNext())
  }, [embla])

  useEffect(() => {
    if (!embla) return
    emblaRef.current = embla
    embla.on('select', onSelect)
    onSelect()
  }, [embla, onSelect])

  useEffect(() => {
    let timeout: any
    if (trackRef) {
      timeout = setTimeout(() => {
        setTrackHeight(trackRef?.current?.scrollHeight)
      }, 1)
    }
    return () => {
      setTrackHeight(false)
      clearTimeout(timeout)
    }
  }, [trackRef])

  return (
    <div className="w-full relative xl:px-12 2xl:px-0">
      <div className="embla relative overflow-hidden my-2" ref={emblaRef}>
        <div className="embla__viewport w-full" ref={viewportRef}>
          <div
            className="embla__container flex gap-2 items-stretch"
            ref={trackRef}
          >
            {typeof children === 'function'
              ? children({ trackHeight })
              : children}
          </div>
        </div>
      </div>
      <div
        className={`inline mx-auto w-max xl:mx-0 absolute top-1/2 -left-5 xl:-left-0 2xl:-left-10`}
      >
        <BidCarouselPrev
          scrollPrev={scrollPrev}
          prevBtnEnabled={prevBtnEnabled}
        />
      </div>
      <div
        className={`inline mx-auto w-max xl:mx-0 absolute top-1/2 -right-5 xl:-right-0 2xl:-right-10`}
      >
        <BidCarouselNext
          scrollNext={scrollNext}
          nextBtnEnabled={nextBtnEnabled}
        />
      </div>
    </div>
  )
}

export default CardSlider
